import { Component, OnInit, Input, OnDestroy } from "@angular/core";
import { ComponentRendering } from "@sitecore-jss/sitecore-jss-angular";
import { JssStylingService } from "../../jss-styling.service";
import { JssContextService } from '../../jss-context.service';
import { Subscription } from 'rxjs';
import { ThemeService } from "../../services/theme.service";

@Component({
    selector: "app-text-block-partner",
    templateUrl: "./text-block-partner.component.html",
})
export class TextBlockPartnerComponent implements OnInit,OnDestroy {
    @Input() rendering: ComponentRendering;
    dynamicClass: string;
    public contextSubscription: Subscription;
  energySaveSubscription: Subscription;
    language: string;
    energySave: boolean;

    constructor(public jssStylingService: JssStylingService,public jssContext: JssContextService, public themeService: ThemeService,) {}

    ngOnInit() {
        this.dynamicClass = this.jssStylingService.getComponentClass(this.rendering);
        this.contextSubscription = this.jssContext.state.subscribe((newState) => {
            this.language = newState.language;
        });

        this.energySaveSubscription = this.themeService.isEnegySaveModeEnabled().subscribe((energySave) => {
              this.energySave = energySave;
        });
    }

    ngOnDestroy(): void {
    if (this.contextSubscription) {
        this.contextSubscription.unsubscribe();
    }
    if (this.energySaveSubscription) {
        this.energySaveSubscription.unsubscribe();
    }
  }
}
